import { Button, ButtonProps } from 'antd';

export type AddButtonProps = Omit<ButtonProps, 'icon'>;

export function AddButton(props: AddButtonProps) {
  return <Button type="primary" {...props} />;
}
